module.exports = __webpack_public_path__ + "static/media/xfinity-verticle-sell-fre.b60d4614.png";